<template>
  <BaseListCard
    title="Conservation Purposes"
    :parentId="instrumentId"
    :parentTitle="'Instrument'"
    :options="{}"
    :entities="entities"
    :entitiesLoading="entitiesLoading"
    :deleteEntity="deleteEntity"
    :emptyEntity="emptyEntity"
    :entitySort="entitySort"
    ref="baseCard"
    >
    <template v-slot:addForm="{ newEntity, options, stopAdding, entityCreated }">
      <ConservationPurposesForm
        :conservationPurpose="newEntity"
        @closeForm="stopAdding">
      </ConservationPurposesForm>
    </template>
    <template v-slot:editForm="{ entity, options, stopEditing, entityUpdated }">
      <ConservationPurposesForm
        :conservationPurpose="entity"
        @closeForm="stopEditing">
      </ConservationPurposesForm>
    </template>
    <template v-slot:entityDetails=" { entity }">
      <div class="row mb-2">
        <div class="col-sm-3">
          <div class="list-header">
            Purpose Name
          </div>
          <div class="list-details">
            {{ getPurposeName(entity.purposeId) }}
          </div>
        </div>
        <div class="col-sm-9">
          <div class="list-header">
            Comments
          </div>
          <div class="list-details notes-field">{{ entity.comments || 'None' }}</div>
        </div>
      </div>
    </template>
  </BaseListCard>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import CollapseParent from '@/mixins/CollapseParent';
import { EntityModules, LookupModules } from '@/store/moduleConfig';
import BaseListCard from '../common/BaseListCard.vue';
import ConservationPurposesForm from './ConservationPurposesForm.vue';

export default {
  name: 'ConservationPurposesCard',
  props: [
    'instrumentId',
  ],
  mixins: [CollapseParent],
  components: {
    BaseListCard,
    ConservationPurposesForm,
  },
  computed: {
    ...mapState(EntityModules.CONSERVATION_PURPOSE.namespace, {
      entities: state => state.entities,
      entitiesLoading: state => state.loading,
    }),
    ...mapGetters(LookupModules.PURPOSES.namespace, {
      getPurposeName: 'getName',
    }),
  },
  created() {
    this.$store.dispatch(`${LookupModules.PURPOSES.namespace}/fetchOptions`,
      LookupModules.PURPOSES.url);
  },
  methods: {
    entitySort(a, b) {
      return this.getPurposeName(a.purposeId)
        .localeCompare(this.getPurposeName(b.purposeId));
    },
    emptyEntity(instrumentId) {
      return {
        instrumentId,
        purposeId: '',
        comments: null,
      };
    },
    deleteEntity(entity) {
      this.$store.dispatch(
        `${EntityModules.CONSERVATION_PURPOSE.namespace}/deleteEntity`, {
          entityType: EntityModules.CONSERVATION_PURPOSE.namespace,
          entity,
        },
      );
    },
  },
};
</script>
